import { autoPlay, Easing, Tween } from "es6-tween";
import React, { useContext, useEffect, useRef, useState } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import styled, { keyframes } from "styled-components";
import { ThemeContext } from "~/lib/ThemeContext";
import { hSpacing } from "~/styles/mixins";
import theme, { hexToRgba, px, rgbWithAlpha, smallerThan } from "~/styles/theme";
import SmallArrowGfx from "./small_arrow.svg"; // set tween autoplay

autoPlay(true);

// hooks
// import useCssCalc from 'hooks/useCssCalc';

// components

// const BlockSliderWrapper = styled.div`
//   width: 100%;
//   position: relative;
//   white-space: nowrap;
//   overflow-x: auto;
//   -webkit-overflow-scrolling: touch;
//   -ms-overflow-style: -ms-autohiding-scrollbar;
//   &::-webkit-scrollbar {
//     display: none;
//   }
// `;

const activeArrow = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(10%);
  }
`;

const SmallArrow = styled(SmallArrowGfx)`
  width: 1.5rem;
`;

const CircleBtn = styled.div`
  cursor: pointer;
  z-index: ${(p) => p.theme.z.body + 20};
  position: absolute;
  /*top: 50%;  should be card height / 2... */
  top: ${(p) => p.top || "50%"};
  /* top: ${(p) => (p.cardSize ? `calc(${p.cardSize} / 2)` : "50%")}; */
  left: ${(p) => (p.left ? `${p.theme.sizes.hSpacing * 2}rem` : "auto")};
  right: ${(p) => (p.right ? `${p.theme.sizes.hSpacing * 2}rem` : "auto")};
  height: 3rem;
  width: 3rem;
  border-radius: 1.5rem;
  transform: translateY(-50%) rotate(${(p) => (p.flip ? "180deg" : "0deg")});
  /* transform: translateY(-50%); */
  background-color: ${(p) =>
    p.color && p.color.startsWith("rgb")
      ? rgbWithAlpha(p.color, 0.6)
      : hexToRgba(p.color, 0.6)};
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
  &:hover {
    ${SmallArrow} {
      animation: 0.6s ${activeArrow} ease-out infinite alternate;
    }
  }
`;

const BlockSliderWrapper = styled.div`
  position: relative;
  &:hover {
    ${CircleBtn} {
      opacity: 1;
      pointer-events: all;
    }
  }
`;

const BlockSliderContainer = styled.div`
  position: relative;
  display: flex;
`;

const Item = styled.div`
  display: inline-block;
  /* width: ${(p) => p.size || "40vw"}; */
  width: calc(${(p) => p.size || "40vw"} - ${(p) => p.theme.sizes.hSpacing * 4}rem);
  flex-shrink: 0; /* force the width, so flex dont take over */
  ${hSpacing};
  white-space: normal;
  margin-right: ${(p) => p.theme.sizes.hSpacing * 4}rem;
  /* ${smallerThan("500px")} {
    width: 75vw;
  } */
  /* ${(p) => smallerThan(p.theme.breakpoints.ipadLandscape)} {
    width: 75vw;
  } */
  ${(p) => smallerThan(p.theme.breakpoints.ipadPortrait)} {
    width: 75vw;
  }
`;

async function scrollLeftToAnim(elem, from, to, duration = 1000) {
  return new Promise((resolve, reject) => {
    const values = { scrollLeft: from }; // Start at (0, 0)

    console.log(elem, from, to);

    new Tween(values)
      .to({ scrollLeft: to }, duration)
      .easing(Easing.Quadratic.Out)
      .on("update", ({ scrollLeft }) => {
        // console.log(scrollLeft);
        elem.scrollLeft = scrollLeft;
      })
      .on("complete", resolve)
      .start();
  });
}

function BlockSlider(props) {
  const currentTheme = useContext(ThemeContext);

  const { children = [], size = "40vw" } = props;
  const [index, setIndex] = useState(0);
  const [atScrollEnd, setAtScrollEnd] = useState(false);
  const [atScrollStart, setAtScrollStart] = useState(true);
  const [canScroll, setCanScroll] = useState(true);
  const scrollContainerRef = useRef();

  // const cardWidthPx = useCssCalc(`${size}`);
  // console.log('cardWidthPx', cardWidthPx);

  // wrap each child in an <Item>
  /*
  const items = React.Children.toArray(props.children).map(child => {
    return <Item size={size}>{child}</Item>;
  });
  */

  const sliderRef = useRef();
  // dirty trick to check title height, to fix offset for arrows..
  // since arrows are not shown before you hover, i guess it's fine 🤷‍♂️
  // should we recalc on resize? we prob should...
  const [titleHeight, setTitleHeight] = useState(null);
  // on mount check title height
  useEffect(() => {
    function checkTitleHeight() {
      if (!sliderRef.current) return;
      let newTitleHeight = 0;
      // find first h3
      const title = sliderRef.current.querySelector("h3");

      // if there is a title height, extract it
      if (title) {
        // console.log(title);
        const titleRect = title.getBoundingClientRect();
        newTitleHeight = titleRect.height || 0;
      }

      // only change, if it has changed...
      if (titleHeight !== newTitleHeight) {
        setTitleHeight(newTitleHeight);
        // console.log('newTitleHeight', newTitleHeight);
      }
    }
    // run at render
    checkTitleHeight();
    // and on resize
    document.addEventListener("resize", checkTitleHeight);

    return () => {
      document.removeEventListener("resize", checkTitleHeight);
    };
  }, []);

  function getItems() {
    return [...sliderRef.current.querySelectorAll(".item")];
  }

  function getCurItemIndex() {
    // get all items
    const items = getItems();
    // get first item that is not below the page margin (theme.sizes.hSpacing)
    const firstVisibleIndex = items.findIndex((item) => {
      const rect = item.getBoundingClientRect();
      const x = rect.x - px(theme.sizes.hSpacing, false);
      console.log("firstVisibleIndex", rect, px(theme.sizes.hSpacing, false));
      if (x >= 0) return true;
      return false;
    });
    // console.log('firstVisibleIndex', firstVisibleIndex);
    return [items.length, firstVisibleIndex];
  }

  async function gotoIndex(index, direction) {
    if (!scrollContainerRef.current) return;

    const container = scrollContainerRef.current.getElement();
    const items = getItems();

    if (direction === "right") {
      // compare first and second item's left value, to determine actual width of a card...
      const right =
        index === 0
          ? 0
          : items[index].getBoundingClientRect().left -
            items[index - 1].getBoundingClientRect().left;

      console.log("right", container.scrollLeft, container.scrollRight);
      console.log(
        "index",
        index,
        index === 0
          ? 0
          : [
              items[index].getBoundingClientRect().left,
              items[index - 1].getBoundingClientRect().left,
            ],
        right
      );

      await scrollLeftToAnim(
        container,
        container.scrollLeft,
        container.scrollLeft + right,
        200
      );
    } else {
      // assume left

      console.log("left", container.scrollLeft, container.scrollRight);

      // compare first and second item's left value, to determine actual width of a card...
      const left = index === 0 ? 0 : items[index - 1].getBoundingClientRect().left;
      const current = items[index].getBoundingClientRect().left;

      console.log("current", current);

      console.log(
        "index",
        index,
        index === 0
          ? 0
          : [
              items[index - 1].getBoundingClientRect().left,
              items[index].getBoundingClientRect().left,
            ],
        left,
        current
      );

      await scrollLeftToAnim(
        container,
        container.scrollLeft,
        index === 0 ? 0 : container.scrollLeft + (current < 0 ? current : left),
        200
      );
    }

    setIndex(index);

    // console.log('done');

    // scroll to the element
    // scrollContainerRef.current.getElement().scrollLeft =
    //   index * cartActualWidht;
  }

  function handleArrowLeft(e) {
    e && e.preventDefault();

    if (!canScroll) return;

    const [_, curIndex] = getCurItemIndex();

    gotoIndex(curIndex === 0 ? 0 : curIndex - 1, "left");
  }

  function handleArrowRight(e) {
    e && e.preventDefault();

    if (!canScroll) return;

    const [total, curIndex] = getCurItemIndex();
    const nextIndex = curIndex + 1;

    if (nextIndex < total) gotoIndex(nextIndex, "right");
  }

  function handleStartScroll(e) {
    setCanScroll(false);
  }

  function handleEndScroll(e) {
    if (!scrollContainerRef.current) return;

    const container = scrollContainerRef.current.getElement();

    setAtScrollEnd(
      container.scrollWidth - container.clientWidth - container.scrollLeft === 0
    );

    setAtScrollStart(container.scrollLeft === 0);

    setCanScroll(true);

    return;

    const [_, curIndex] = getCurItemIndex();
    console.log("handleScroll curIndex", curIndex);
    if (curIndex !== index) {
      setIndex(curIndex);
    }
    // const elem = scrollContainerRef.current.getElement();
    // const rect = elem.getBoundingClientRect();
    // console.log(rect.width, elem.scrollLeft);

    // const items = getItems();
    // const lastItem = items[items.length - 1];
    // const lastItemRect = lastItem.getBoundingClientRect();
    // console.log(lastItemRect);

    // console.preventDefault
    // console.log(scrollContainerRef.current.getElement().scrollLeft);
  }

  // console.log(index);

  return (
    <BlockSliderWrapper>
      <ScrollContainer
        ref={scrollContainerRef}
        vertical={false}
        horizontal
        hideScrollbars
        onStartScroll={handleStartScroll}
        onEndScroll={handleEndScroll}
      >
        {titleHeight !== null && !atScrollStart && (
          <CircleBtn
            color={
              currentTheme.name === "dark" ? currentTheme.highlight : theme.colors.light
            }
            left
            onClick={handleArrowLeft}
            top={`calc(${size} / 2 + ${titleHeight}px)`}
            flip
          >
            <SmallArrow />
          </CircleBtn>
        )}
        <BlockSliderContainer ref={sliderRef}>
          {React.Children.toArray(children).map((child, i) => {
            const { size = props.size } = child.props;
            return (
              <Item key={i} size={size} className="item">
                {child}
              </Item>
            );
          })}
        </BlockSliderContainer>
        {titleHeight !== null && !atScrollEnd && (
          <CircleBtn
            color={
              currentTheme.name === "dark" ? currentTheme.highlight : theme.colors.light
            }
            right
            onClick={handleArrowRight}
            top={`calc(${size} / 2 + ${titleHeight}px)`}
          >
            <SmallArrow />
          </CircleBtn>
        )}
      </ScrollContainer>
    </BlockSliderWrapper>
  );
}

export default BlockSlider;
